import { gql } from "@apollo/client";

export const activeUsersReportByRange = gql(`
  query activeUsersReportByRange($startDate: String, $endDate: String) {
    analyticsReport(input: {
      startDate: $startDate
      endDate: $endDate
      dimensions: ["date"]
      metrics: ["activeUsers", "sessions"]
    }) {
      dimensionHeaders
      metricHeaders
      rows { dimensionValues metricValues }
      totals { dimensionValues metricValues }
      rowCount
    }
  }
`)

export const activeUsersSummaryByRange = gql(`
  query activeUsersSummaryByRange($startDate: String, $endDate: String) {
    analyticsReport(input: {
      startDate: $startDate
      endDate: $endDate
      dimensions: []
      metrics: ["activeUsers", "sessions"]
      limit: 1
    }) {
      metricHeaders
      rows { metricValues }
    }
  }
`)

export const engagementReportByRange = gql(`
  query engagementReportByRange($startDate: String, $endDate: String) {
    analyticsReport(input: {
      startDate: $startDate
      endDate: $endDate
      dimensions: ["date"]
      metrics: ["userEngagementDuration", "activeUsers", "engagedSessions"]
    }) {
      dimensionHeaders
      metricHeaders
      rows { dimensionValues metricValues }
      totals { dimensionValues metricValues }
      rowCount
    }
  }
`)

export const engagementSummaryByRange = gql(`
  query engagementSummaryByRange($startDate: String, $endDate: String) {
    analyticsReport(input: {
      startDate: $startDate
      endDate: $endDate
      dimensions: []
      metrics: ["userEngagementDuration", "activeUsers", "engagedSessions"]
      limit: 1
    }) {
      metricHeaders
      rows { metricValues }
    }
  }
`)

export const activeUsersByCityReportByRange = gql(`
  query activeUsersByCityReportByRange($startDate: String, $endDate: String) {
    analyticsReport(input: {
      startDate: $startDate
      endDate: $endDate
      dimensions: ["city"]
      metrics: ["activeUsers"]
      limit: 10
    }) {
      dimensionHeaders
      metricHeaders
      rows { dimensionValues metricValues }
      totals { dimensionValues metricValues }
      rowCount
    }
  }
`)

export const activeUsersByPlatformReportByRange = gql(`
  query activeUsersByPlatformReportByRange($startDate: String, $endDate: String) {
    analyticsReport(input: {
      startDate: $startDate
      endDate: $endDate
      dimensions: ["platform"]
      metrics: ["activeUsers"]
    }) {
      dimensionHeaders
      metricHeaders
      rows { dimensionValues metricValues }
      totals { dimensionValues metricValues }
      rowCount
    }
  }
`)

export const activeUsersByAppVersionReportByRange = gql(`
  query activeUsersByAppVersionReportByRange($startDate: String, $endDate: String) {
    analyticsReport(input: {
      startDate: $startDate
      endDate: $endDate
      dimensions: ["date", "appVersion"]
      metrics: ["activeUsers"]
    }) {
      dimensionHeaders
      metricHeaders
      rows { dimensionValues metricValues }
      totals { dimensionValues metricValues }
      rowCount
    }
  }
`)

export const selectBandReportByRange = gql(`
  query selectBandReportByRange($startDate: String, $endDate: String) {
    analyticsReport(input: {
      startDate: $startDate
      endDate: $endDate
      dimensions: ["eventName", "customEvent:bandName", "customEvent:priority"]
      metrics: ["eventCount"]
      eventNameFilter: "select_band"
      limit: 500
    }) {
      dimensionHeaders
      metricHeaders
      rows { dimensionValues metricValues }
      totals { dimensionValues metricValues }
      rowCount
    }
  }
`)

export const activeUsersReport = gql(`query activeUsersReport {
  analyticsReport(input: {
    startDate: "30daysAgo"
    endDate: "yesterday"
    dimensions: ["date"]
    metrics: ["activeUsers", "sessions"]
  }) {
    dimensionHeaders
    metricHeaders
    rows {
      dimensionValues
      metricValues
    }
    totals {
      dimensionValues
      metricValues
    }
    rowCount
  }
}`)

export const activeUsersSummary = gql(`query activeUsersSummary {
  analyticsReport(input: {
    startDate: "30daysAgo"
    endDate: "yesterday"
    dimensions: []
    metrics: ["activeUsers", "sessions"]
    limit: 1
  }) {
    metricHeaders
    rows {
      metricValues
    }
  }
}`)

export const engagementReport = gql(`query engagementReport {
  analyticsReport(input: {
    startDate: "30daysAgo"
    endDate: "yesterday"
    dimensions: ["date"]
    metrics: ["userEngagementDuration", "activeUsers", "engagedSessions"]
  }) {
    dimensionHeaders
    metricHeaders
    rows {
      dimensionValues
      metricValues
    }
    totals {
      dimensionValues
      metricValues
    }
    rowCount
  }
}`)

export const engagementSummary = gql(`query engagementSummary {
  analyticsReport(input: {
    startDate: "30daysAgo"
    endDate: "yesterday"
    dimensions: []
    metrics: ["userEngagementDuration", "activeUsers", "engagedSessions"]
    limit: 1
  }) {
    metricHeaders
    rows {
      metricValues
    }
  }
}`)

export const activeUsersByCityReport = gql(`query activeUsersByCityReport {
  analyticsReport(input: {
    startDate: "30daysAgo"
    endDate: "yesterday"
    dimensions: ["city"]
    metrics: ["activeUsers"]
    limit: 10
  }) {
    dimensionHeaders
    metricHeaders
    rows {
      dimensionValues
      metricValues
    }
    totals {
      dimensionValues
      metricValues
    }
    rowCount
  }
}`)

export const activeUsersByPlatformReport = gql(`query activeUsersByPlatformReport {
  analyticsReport(input: {
    startDate: "30daysAgo"
    endDate: "yesterday"
    dimensions: ["platform"]
    metrics: ["activeUsers"]
  }) {
    dimensionHeaders
    metricHeaders
    rows {
      dimensionValues
      metricValues
    }
    totals {
      dimensionValues
      metricValues
    }
    rowCount
  }
}`)

export const activeUsersByAppVersionReport = gql(`query activeUsersByAppVersionReport {
  analyticsReport(input: {
    startDate: "30daysAgo"
    endDate: "yesterday"
    dimensions: ["date", "appVersion"]
    metrics: ["activeUsers"]
  }) {
    dimensionHeaders
    metricHeaders
    rows {
      dimensionValues
      metricValues
    }
    totals {
      dimensionValues
      metricValues
    }
    rowCount
  }
}`)

export const selectBandReport = gql(`query selectBandReport {
  analyticsReport(input: {
    startDate: "30daysAgo"
    endDate: "today"
    dimensions: ["eventName", "customEvent:bandName", "customEvent:priority"]
    metrics: ["eventCount"],
    eventNameFilter: "select_band"
    limit: 500
  }) {
    dimensionHeaders
    metricHeaders
    rows {
      dimensionValues
      metricValues
    }
    totals {
      dimensionValues
      metricValues
    }
    rowCount
  }
}`)
